
(function () {

  var screen_width = window.innerWidth;
  var mobile_safe_vh_unit = function() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--mobile-safe-vh-unit', vh + 'px');
  };
  window.addEventListener('resize', function() {
    if (window.innerWidth !== screen_width) {
      screen_width = window.innerWidth;
      mobile_safe_vh_unit();
    }
  });
  mobile_safe_vh_unit();

  // Apartments images
  let images = document.querySelector('.js-apartment-images');
  let image_selectors = document.querySelectorAll('.js-apartment-image');

  for (const selector of image_selectors) {
    selector.addEventListener('click', function() {
      for (const image of images.children) {
        if (selector.getAttribute('data-id') === image.getAttribute('id')) {
          if (!image.classList.contains('active')) {
            image.classList.add('active');
          }
        } else {
          image.classList.remove('active');
        }
      }
    });
  }

}());

